import React, { useState, Fragment, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button, Input,
    Row, Label
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import ReactQuill from 'react-quill';
import 'rc-switch/assets/index.css';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ]
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];
export default function StandaloneLocation({ pageSettings, saveIntegration }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(pageSettings.location !== null &&
        !pageSettings.location.disabled
    );
    const [enableAddress, setEnableAddress] = useState(pageSettings.location !== null &&
        pageSettings.location.enabledAddress
    );
    const [locationData, setLocationData] = useState({
        locationLink: "",
        address: ""
    });
    useEffect(() => {
        if (pageSettings !== undefined && pageSettings.location !== null) {
            setLocationData({
                ...pageSettings.location,
                locationLink: pageSettings.location.locationLink,
                address: pageSettings.location.address
            });
        }
    }, [pageSettings]);

    const handleChange = (e) => {
        setLocationData({
            ...locationData,
            locationLink: e.target.value
        });
    }
    const handleChangeAddress = (source, data) => {
        if (source === 'user') {
            setLocationData({
                ...locationData,
                address: data
            });
        }
    }
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setLocationData({
            ...locationData,
            disabled: !value
        });
    };
    const handleSwitchAddressChange = (value) => {
        setEnableAddress(value);
        setLocationData({
            ...locationData,
            enabledAddress: value
        });
    };
    const handleSave = () => {
        let setting = pageSettings;
        setting.location = locationData;
        saveIntegration({
            pageSettings: setting
        });
    };

    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Location Info</h6>
                </div>
                <Separator className="mb-3" />
                <Row>
                    <Colxx md={12} className='mt-2'>
                        <div className="d-flex w-100">
                            <Label>Embed Map</Label>
                            <Switch
                                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className='mt-2'>
                        <Label>URL</Label>
                        <div className="mb-2">
                            <Input
                                type="textarea"
                                value={locationData.locationLink}
                                onChange={(e) => handleChange(e)}
                                name="locationLink"
                                style={{ height: "100px" }}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className="mt-2">
                        <div className="d-flex w-100">
                            <Label>Location Information</Label>
                            <Switch
                                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                                checked={enableAddress}
                                onChange={(primary) => handleSwitchAddressChange(primary)}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className="mt-2">
                        <Label>Address</Label>
                        <ReactQuill
                            theme="snow"
                            value={locationData.address}
                            onChange={(content, delta, source) =>
                                handleChangeAddress(source, content)
                            }
                            modules={quillModules}
                            formats={quillFormats}
                            name="address"
                        />
                    </Colxx>
                    <Separator className="mt-2 " />
                    <Colxx md={12} className="mt-2">
                        <div className="mb-1 mt-4 ml-2 text-center">
                            <Button
                                color="primary"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
        </Card>
    );

}